import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Undo confirmation shared by every dashboard entity's delete flow (Roles
 * today, Collaborators/Campaigns next) — pairs with `useUndoDelete`. Same
 * top-center placement as `SuccessSnackbar`. "Desfazer" restores; closing
 * (the X or auto-hide) just discards — it never restores on its own.
 */
export default function UndoSnackbar({ pending, onUndo, onDismiss, undoLabel, autoHideDuration = 6000 }) {
  return (
    <Snackbar
      open={Boolean(pending)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={autoHideDuration}
      onClose={(event, reason) => {
        if (reason !== 'clickaway') onDismiss();
      }}
      message={pending?.message}
      action={
        <>
          <Button color="inherit" size="small" onClick={onUndo}>
            {undoLabel}
          </Button>
          <IconButton size="small" color="inherit" onClick={onDismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
